var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_23806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 3.64616C5.1875 5.0847 4.03125 6.25032 2.60417 6.25032C1.17708 6.25032 0.0208333 5.0847 0.0208333 3.64616C0.0208333 2.20866 1.17708 1.04199 2.60417 1.04199C4.03125 1.04199 5.1875 2.20866 5.1875 3.64616ZM5.20833 8.33366H0V25.0003H5.20833V8.33366ZM13.5229 8.33366H8.34792V25.0003H13.524V16.2514C13.524 11.3868 19.8042 10.9889 19.8042 16.2514V25.0003H25V14.4472C25 6.23887 15.7063 6.53782 13.5229 10.5784V8.33366Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_23806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5b17c7e4dd3c54307569e42215e49ef7.svg";
export { ForwardRef as ReactComponent };